import React, { useEffect, useState } from "react";
import { Title } from "../../../../../stories/Title/Title";
import Close from "../../../../../images/Close.svg";
import { Tab, Tabs } from "@mui/material";
import { a11yProps, TabPanel } from "../../../../../styles/Tabs";
import { Button } from "../../../../../stories/Button/Button";
import { StyledDatagrid } from "../../../../../styles/DatagridStyles";
import useAssetTableJson from "../../../../../json/useAssetTableJson";
import { TableHeaderProps } from "../../../../../utils/types";
import {
  GridAlignment,
  GridColDef,
  GridColumnVisibilityModel,
  GridValidRowModel
} from "@mui/x-data-grid-pro";
import EyeWhite from "../../../../../images/EyeWhite.svg";
import { TABLE_ROW_HEIGHT } from "../../../../../styles/Variables";
import { ColumnVisibilityFor } from "../../../../../utils/Enum.Datagrid";
import { CustomModal } from "../../../../../utils/UtilFunctions";
import { ViewModalStyles } from "../../../../../styles/CustomModalStyles";
import ViewCompleteDetails  from "./ViewCompleteDetails";
import AssetWiseDetails from "./AssetWiseDetails";
import useLabels from "../../../../../customHooks/useLabels";
interface Props {
  setModalFlag: React.Dispatch<React.SetStateAction<boolean>>;
}
const Data = [
  {
    name: "Shivaji Nagar",
    total: 0
  }
];
const CompanyDetails = ({ setModalFlag }: Props) => {
  const [completeDetails, setCompleteDetails] = useState(false);
  const [value, setValue] = useState(0);
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  const { Maps } = useAssetTableJson();
  const dynamicHeaders: TableHeaderProps[] = Maps.ItemDetails.map((header) => ({
    headerName: header.headerName,
    field: header.field,
    headerAlign: header.headerAlign as GridAlignment,
    align: header.align as GridAlignment,
    flex: header.flex,
    hideable: header.hideable,
    cellClassName: header.cellClassName,
    renderCell: (params) => {
      if (header.field === "actions") {
        return (
          <>
            <button
              className="maps-comp-details__view"
              onClick={() => setCompleteDetails(!completeDetails)}
            >
              View Details <img src={EyeWhite} alt="" />
            </button>
          </>
        );
      }

      return params.value;
    }
  }));
  const columns: GridColDef[] = [...dynamicHeaders];
  const rows1: GridValidRowModel[] =
    (Data || []).map((data, index) => {
      return {
        id: index + 1,
        subsidiary_name: data.name,
        total: data.total
      };
    }) || [];

  const [columnVisibilityModel, setColumnVisibilityModel] =
    useState<GridColumnVisibilityModel>({});

  useEffect(() => {
    const savedModel = localStorage.getItem(
      ColumnVisibilityFor.MAPS_COMPANY_DETAILS
    );
    if (savedModel) {
      setColumnVisibilityModel(JSON.parse(savedModel));
    }
  }, []);

  const handleColumnVisibilityChange = (
    newModel: GridColumnVisibilityModel
  ) => {
    setColumnVisibilityModel(newModel);
    localStorage.setItem(
      ColumnVisibilityFor.MAPS_COMPANY_DETAILS,
      JSON.stringify(newModel)
    );
  };
  const {companyLabel,subsidiaryLabel,itemLabel}=useLabels();
  return (
    <div className="maps-comp-details">
      <div className="maps-comp-details__title">
        <Title>{companyLabel}</Title>
        <img src={Close} alt="" onClick={() => setModalFlag(false)} />
      </div>
      <div className="maps-comp-details__tabs">
        <Tabs value={value} onChange={handleChange}>
          <Tab label={`${subsidiaryLabel} Wise` }value={0} {...a11yProps(0)} />

          <Tab label={`${itemLabel} Wise`}value={1} {...a11yProps(1)} />
        </Tabs>
      </div>
      <div className="maps-comp-details__tab-panel">
        <TabPanel value={value} index={0}>
          <div className="maps-comp-details__tab-panel--h">
            <b className="maps__item--header--lb">Bangalore Traffic Police</b>
            <div className="maps__item--asset-location">
              <div className="maps__item--asset-location--t">
                <span>Total {subsidiaryLabel}</span>
                <b>0</b>
              </div>
              <div className="maps__item--asset-location--t">
                <span>Total {itemLabel}</span>
                <b>0</b>
              </div>
            </div>
          </div>

          <div className="maps-comp-details__tableblock">
            <StyledDatagrid
              columns={columns}
              rows={rows1}
              rowHeight={TABLE_ROW_HEIGHT}
              columnVisibilityModel={columnVisibilityModel}
              onColumnVisibilityModelChange={handleColumnVisibilityChange}
              initialState={{
                columns: {
                  columnVisibilityModel: columnVisibilityModel
                }
              }}
              disableRowSelectionOnClick
              hideFooter
            />
          </div>
        </TabPanel>
        <TabPanel value={value} index={1}>
          <AssetWiseDetails />
        </TabPanel>
      </div>
      <Button mode="cancel" onClick={() => setModalFlag(false)} />

      <CustomModal
        style={ViewModalStyles}
        isOpen={completeDetails}
        onRequestClose={() => setCompleteDetails(!completeDetails)}
        contentComponent={
          <ViewCompleteDetails setModalFlag={setCompleteDetails} />
        }
      />
    </div>
  );
};

export default CompanyDetails;
